import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateOrderRateReasonEntity } from '../../domain/entities/CreateUpdateOrderRateReasonEntity'

export class CreateUpdateOrderRateReasonModel extends CreateUpdateOrderRateReasonEntity {
  channelId?: number
  constructor(dataDto: CreateUpdateOrderRateReasonEntity) {
    super()
    mapEntityProperties<CreateUpdateOrderRateReasonModel>(this, dataDto, {
      exclude: ['channel'],
      map: {
        channelId: dataDto.channel?.id
      }
    })
  }
}
